import BigPicture from 'bigpicture'; // BigPicture lightbox for popout video players and property image galleries.

export function bigPictureInit() {
	const listingVideos = document.querySelectorAll('.listing-video');

	listingVideos.forEach((item) =>
		item.addEventListener('click', function (e) {
			BigPicture({
				el: item,
				ytSrc: item.dataset.ytsrc,
			});
		}),
	);

	// Property gallery and video tour.
	const propertyPhotos = document.querySelectorAll(
		'.property-photos .glide__slide img',
	);
	const galleryTrigger = document.querySelector('.property-photos__count');
	const tourTrigger = document.querySelector('.property-photos__tour');
	const accordionGalleries = document.querySelectorAll(
		'.accordion__gallery-item img',
	);

	if (propertyPhotos) {
		propertyPhotos.forEach((item) =>
			item.addEventListener('click', function (e) {
				BigPicture({
					el: e.target,
					gallery: document.querySelectorAll(
						'.property-photos .glide__slide:not(.glide__slide--clone) img',
					),
					galleryAttribute: 'data-full',
				});
			}),
		);
	}

	if (galleryTrigger) {
		galleryTrigger.addEventListener('click', function (e) {
			BigPicture({
				el: e.target,
				gallery: document.querySelectorAll(
					'.property-photos .glide__slide:not(.glide__slide--clone) img',
				),
				galleryAttribute: 'data-full',
			});
		});
	}

	if (tourTrigger) {
		tourTrigger.addEventListener('click', function (e) {
			BigPicture({
				el: tourTrigger,
				ytSrc: tourTrigger.dataset.ytsrc,
			});
		});
	}

	if (accordionGalleries) {
		accordionGalleries.forEach((item) =>
			item.addEventListener('click', function (e) {
				BigPicture({
					el: e.target,
					imgSrc: e.target.dataset['full'],
				});
			}),
		);
	}
}
